import { defineStore } from 'pinia';
import request from '@/utils/request';
import Cookies from 'js-cookie';
import { ElMessage } from 'element-plus';

export const useViewCountStore = defineStore('ViewCount', {
    state: () => ({
        siteViewCount: 0,
    }),

    getters: {
        getSiteViewCount: state => state.siteViewCount,
    },

    actions: {
        // 获取网站浏览量
        async fetchSiteViewCount() {
            const res: any = await request({
                url: `/api/siteView`,
                method: 'get',
            });
            if (res.code === 200) {
                // console.log('fetchSiteViewCount', res);
                this.siteViewCount = res.data.result.viewCount;
                return this.siteViewCount;
            } else {
                ElMessage.error(res.message);
            }
        },
        // 增加网站浏览量
        async addSiteViewCount() {
            const res: any = await request({
                url: `/api/siteView`,
                method: 'post',
            });
            if (res.code === 200) {
                // console.log('addSiteViewCount', res);
                this.siteViewCount = res.data.result.viewCount;
            } else {
                ElMessage.error(res.message);
            }
        },
    },
    persist: true,
});
